import 'highlight.js/styles/mono-blue.css';
import hljs from 'highlight.js';

const highlightLines = (fileExtension, lines) => {
  const formattedLines = [];
  let fileformat = fileExtension;
  if (fileExtension === "m") {
    fileformat = "objectivec";
  }
  if (fileExtension === "tsx") {
    fileformat = "typescript";
  }
  if (fileExtension === "jsx") {
    fileformat = "javascript";
  }
  if (fileExtension === "kt") {
    fileformat = "kotlin";
  }
  lines.forEach((line) => {
    const result = hljs.highlight(line, {
      language: fileformat,
      ignoreIllegals: true
    });
    formattedLines.push(result.value);
  });
  return formattedLines;
};

export { highlightLines };
//# sourceMappingURL=Highlighter.esm.js.map
